export enum CustomerTags {
  HidePriceMineLicenser = 'HidePriceMineLicenser', 
  AllowHighRiskProducts = 'AllowHighRiskProducts'
}
  
  